import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';

import { Container } from "reactstrap";

import Channels from "../../components/Channels";

import { getAllChannels, deleteChannel } from "../../store/actions/channels";


const Dashboard = props => {
  useEffect(() => {
    if (Object.keys(props.channels).length < 2) props.getAllChannels();
  });
  return (
    <Container fluid>
      <h4 className="mb-4">لیست کانال‌ها</h4>
      {!props.loadingChannel &&
        <Channels
          onDelete={props.deleteChannel}
          channels={Object.values(props.channels).sort((a, b) => { return b.id - a.id })}
        />
      }
    </Container>
  )
}


export default connect(
  state => (
    {
      channels: state.channels,
      loadingChannel: state.loading.channel
    }
  ),
  dispatch => bindActionCreators({
    getAllChannels,
    deleteChannel
  }, dispatch)
)(Dashboard)